import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import AppButton from "@/features/line-sheet-sets/app-button";
import CustomIcon from "../../../../../../../public/icons-v1_1";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import PathPickProductCard from "@/features/pathpick/components/product/PathPickProductCard";
import { isPathPickProductSoldOut } from "@/features/pathpick/utils";
import {
  PathPickMarketPriceBasis,
  PathPickProduct,
} from "@/features/pathpick/types";

interface Props {
  item: PathPickProduct;
  isSelected: boolean;
  marketPriceBasis: PathPickMarketPriceBasis;
  // 부모는 identity가 고정된 핸들러를 넘겨야 한다(아래 memo 경계가 유지되는 조건).
  onToggleSelect: (item: PathPickProduct) => void;
  onOpenSizeStock: (item: PathPickProduct) => void;
  onDelete: (item: PathPickProduct) => void;
  onOrder: (item: PathPickProduct) => void;
  // 카드가 인자를 담아 호출하므로 클로저를 만들지 않고 그대로 넘긴다(memo 경계 유지).
  onOpenRequestDetail: (params: { requestId: number; sku: string }) => void;
}

// 담은 상품 그리드의 카드 1장 — 선택 토글에 목록 전체가 리렌더되지 않도록 memo 경계를 만든다.
// 카드에 넘기는 0-arg 클로저와 actions 엘리먼트를 부모가 아니라 이 안에서 만드는 것이 핵심이다.
function PathPickBasketProductGridItem({
  item,
  isSelected,
  marketPriceBasis,
  onToggleSelect,
  onOpenSizeStock,
  onDelete,
  onOrder,
  onOpenRequestDetail,
}: Props) {
  const { t } = useI18nHelper();

  // 품절 상품은 카드를 dim 처리하고 주문만 막는다 — 선택과 삭제는 그대로 살려둔다.
  const isSoldOut = isPathPickProductSoldOut(item);

  return (
    <PathPickProductCard
      item={item}
      marketPriceBasis={marketPriceBasis}
      isSelected={isSelected}
      isSoldOut={isSoldOut}
      onToggleSelect={() => onToggleSelect(item)}
      onOpenSizeStock={() => onOpenSizeStock(item)}
      onOpenRequestDetail={onOpenRequestDetail}
      actions={
        <>
          <AppButton
            variant={"white"}
            width={"100%"}
            onClick={() => onDelete(item)}
          >
            <Flex gap={"4px"} alignItems={"center"} justifyContent={"center"}>
              <CustomIcon src={"trash"} width={16} height={16} />
              <Text textStyle={"body-sm-bold"}>
                {t("path_pick:basket.card.delete")}
              </Text>
            </Flex>
          </AppButton>
          <AppButton
            variant={"white"}
            width={"100%"}
            isDisabled={isSoldOut}
            onClick={() => onOrder(item)}
          >
            <Flex gap={"4px"} alignItems={"center"} justifyContent={"center"}>
              <CustomIcon src={"cart"} width={16} height={16} />
              <Text textStyle={"body-sm-bold"}>
                {t(
                  isSoldOut
                    ? "path_pick:basket.card.sold_out"
                    : "path_pick:search_products.product_list.order"
                )}
              </Text>
            </Flex>
          </AppButton>
        </>
      }
    />
  );
}

export default React.memo(PathPickBasketProductGridItem);
